import { Box, TextField, Tooltip, Typography } from "@mui/material";
import React from "react";
import {
  Controller,
  type Control,
  type FieldValues,
  type Path,
} from "react-hook-form";

type Props<T extends FieldValues> = {
  required?: boolean | null;
  patternMessage?: string;
  pattern?: RegExp;
  control: Control<T>;
  name: Path<T>;
};

export const DynamicFormInput = <T extends FieldValues>(props: Props<T>) => {
  return (
    <Box sx={{ mt: 1 }}>
      <Controller
        name={props.name}
        control={props.control}
        rules={{
          required: props.required ? "This field is required" : false,
          minLength: {
            value: 2,
            message: "Minimum length is 2 characters",
          },
          pattern: props.pattern && {
            value: props.pattern,
            message: props.patternMessage || "Invalid format",
          },
        }}
        render={({ field, fieldState }) => (
          <Box>
            {props.required && (
              <Typography
                color="warning"
                sx={{
                  fontSize: "12px",
                  opacity: 0.7,
                  marginTop: "-2px",
                  marginBottom: "0px",
                  // display: "inline",
                }}
              >
                * Påkrævet
              </Typography>
            )}
            <Box
              sx={{
                height: "0px",
                display: "flex",
                justifyContent: "end",
                width: "100%",
              }}
            >
              <Tooltip
                title={fieldState.error?.message || "Error"}
                open={!!fieldState.error}
                placement="top-end"
                arrow
              >
                <Box></Box>
              </Tooltip>
            </Box>
            <TextField {...field} fullWidth error={!!fieldState.error} />
          </Box>
        )}
      />
    </Box>
  );
};
